import { apiCall } from "../../services/api-service";

export const getRenewalReminderListApi = (params) =>
  apiCall("get", `renewal_reminder?${params}`);

export const getRenewalListApi = (params) =>
  apiCall("get", `renewal?${params}`);

export const getVehicleDetailsApi = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const submitRenewalAPI = (body) =>
  apiCall("post", "renewal", body);

export const saveAttachmentApi = (id, body) =>
  apiCall("put", `renewal/add_attachment/${id}`, body);

export const updateRenewalAPI = (id, body) =>
  apiCall("put", `renewal/${id}`, body);

export const getRenewalDetailsApi = (id) =>
  apiCall("get", `renewal/view/${id}`);

export const getRenewalEditApi = (id) =>
  apiCall("get", `renewal/edit/${id}`);

export const getRenewalReminderDetailsApi = (id) =>
  apiCall("get", `renewal_reminder/view/${id}`);


